import React from "react";
// import './index.css'
import {
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  useReactTable,
} from "@tanstack/react-table";
import Pagination from "./Pagination";
import { FadeLoader } from "react-spinners";

function Table({
  data,
  columns,
  orderCol,
  orderType,
  tableType,
  setOrderCol,
  setOrderType,
  rowClick,
  isLoading,
  ...props
}) {
  const table = useReactTable({
    data,
    columns,
    // Pipeline
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    // getPaginationRowModel: getPaginationRowModel(),
    //
    debugTable: true,
  });

  const handleOrder = (column) => {
    let orType = "";

    if (orderCol === column?.column?.columnDef?.fieldName) {
      if (orderType === "") {
        orType = "ASC";
      } else if (orderType === "ASC") {
        orType = "DESC";
      } else if (orderType === "DESC") {
        orType = "";
        setOrderCol("");
      }
    } else {
      setOrderCol(column?.column?.columnDef?.fieldName);
      orType = "ASC";
    }

    setOrderType(orType);
    props.gotoPage(
      props?.pageIndex,
      orType === "" ? "" : column?.column?.columnDef?.fieldName,
      orType === "" ? "" : column?.column?.columnDef?.fieldAPIName,
      orType
    );
  };

  return (
    <div className="table-container h-full flex flex-col overflow-hidden">
      <div
        className={`grow bg-white-100 md:rounded-lg overflow-auto relative`}
        id="prod-modal-body"
      >
        <table className="w-full">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header, i) => {
                  return (
                    <th
                      className={`:min-w-fit cursor-pointer p-3 font-bold ${
                        i === 0 ? "md:rounded-tl-lg" : ""
                      } ${
                        i === headerGroup.headers.length - 1
                          ? "md:rounded-tr-lg"
                          : ""
                      } ${
                        i === 0
                          ? "left-0 z-[3]  !min-w-[150px]"
                          : "!min-w-[200px]"
                      }`}
                      key={header.id}
                      colSpan={header.colSpan}
                      onClick={() => handleOrder(header)}
                    >
                      {header.isPlaceholder ? null : (
                        <div>
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                          <span className="absolute right-3 top-50">
                            {orderCol ===
                              header?.column?.columnDef?.fieldName &&
                            (orderType === "ASC" || orderType === "DESC") ? (
                              orderType === "DESC" ? (
                                <div className="accIconClose inline-block rotate-45 ml-2" />
                              ) : (
                                <div className="accIconOpen inline-block mr-3 ml-2" />
                              )
                            ) : (
                              ""
                            )}
                          </span>
                        </div>
                      )}
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row, i) => {
              const ifActive = row.getAllCells().find((dt) => {
                return (
                  tableType === "user" &&
                  dt?.column?.columnDef?.fieldName === "active" &&
                  dt?.getValue(dt?.column.id) === true
                );
              });

              return (
                <tr
                  className={`${
                    tableType !== "user" || ifActive
                      ? "cursor-pointer"
                      : tableType === "user"
                      ? "cursor-not-allowed"
                      : ""
                  }`}
                  onClick={() => {
                    if (tableType !== "user" || ifActive) {
                      rowClick({ ...row, index: i });
                    }
                  }}
                  key={row.id}
                >
                  {row.getVisibleCells().map((cell, i2) => {
                    return (
                      <td
                        key={cell.id}
                        className={`p-3 ${
                          tableType !== "user" || ifActive
                            ? ""
                            : "!text-[color:#868686]"
                        } ${i2 === 0 ? "sticky left-0 z-[2]" : ""}`}
                      >
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        {isLoading ? (
          <div className="table-spinner min-w-full max-h-full min-h-full max-w-[100vw] text-center z-10">
            <FadeLoader color="#e11b22" />
          </div>
        ) : (
          ""
        )}
      </div>
      {props.pageCount > 0 ? (
        <div className="pagination flex flex-row md:justify-end justify-center mt-5">
          <Pagination {...props} />
        </div>
      ) : null}
    </div>
  );
}

function Filter({ column, table }) {
  const firstValue = table
    .getPreFilteredRowModel()
    .flatRows[0]?.getValue(column.id);

  const columnFilterValue = column.getFilterValue();

  return typeof firstValue === "number" ? (
    <div className="flex space-x-2">
      <input
        type="number"
        value={columnFilterValue?.[0] ?? ""}
        onChange={(e) =>
          column.setFilterValue((old) => [e.target.value, old?.[1]])
        }
        placeholder={`Min`}
        className="w-24 border shadow rounded"
      />
      <input
        type="number"
        value={columnFilterValue?.[1] ?? ""}
        onChange={(e) =>
          column.setFilterValue((old) => [old?.[0], e.target.value])
        }
        placeholder={`Max`}
        className="w-24 border shadow rounded"
      />
    </div>
  ) : (
    <input
      type="text"
      value={columnFilterValue ?? ""}
      onChange={(e) => column.setFilterValue(e.target.value)}
      placeholder={`Search...`}
      className="w-36 border shadow rounded"
    />
  );
}

export default Table;
